import { Controller } from "@hotwired/stimulus"

// Facebook's newer player uses the URL width instead of the iframe viewport.
export default class extends Controller {
  connect() {
    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => this.resizePlayer(), 150)
    })
    this.resizeObserver.observe(this.element)
    this.resizePlayer()
  }

  disconnect() {
    this.resizeObserver.disconnect()
    clearTimeout(this.resizeTimer)
  }

  resizePlayer() {
    const width = Math.floor(this.element.getBoundingClientRect().width)
    if (!width || width === this.playerWidth) return

    this.playerWidth = width
    const iframe = this.element.querySelector("iframe")
    const url = new URL(iframe.src)
    if (url.searchParams.get("width") === String(width)) return
    url.searchParams.set("width", width)
    iframe.src = url.toString()
  }
}
